/**
 * @module builder
 */
import type { OptionsDocument, QuoteDocument } from 'paintscout'

import findIndex from 'lodash/findIndex'
import cloneDeep from 'lodash/cloneDeep'
import { calculateQuote } from '../../util'
import { uuid } from '../../../util'
import { getItem } from '../../items/get-items'
import { getFileKeysForItem, getFiles, updateFiles } from '../../files'

export function copyLineItem(args: {
  quote: QuoteDocument
  options: OptionsDocument
  key: string
  calculate?: boolean
  useKey?: string
}): QuoteDocument {
  const { quote, options, key, calculate, useKey } = args

  const newKey = useKey ? useKey : uuid()
  const lineItem = cloneDeep(quote.lineItems[key])
  lineItem.key = newKey

  const orderItem = {
    key: newKey,
    type: 'line_item'
  }

  const areaOrder = [...quote.order.area]
  const areaIndex = findIndex(areaOrder, { key })
  areaOrder.splice(areaIndex + 1, 0, orderItem)

  const substrateOrder = [...quote.order.substrate]
  const substrateIndex = findIndex(substrateOrder, { key })
  substrateOrder.splice(substrateIndex, 0, orderItem)

  const updatedQuote = {
    ...quote,
    lineItems: {
      ...quote.lineItems,
      [newKey]: lineItem
    },
    order: {
      ...quote.order,
      area: areaOrder,
      substrate: substrateOrder
    }
  }

  const updateableItem = getItem({ quote, options, key })
  const fileKeys = getFileKeysForItem({ item: updateableItem })
  const copiedFiles = getFiles({ quote, keys: fileKeys }).map((file) => ({
    ...file,
    key: uuid()
  }))

  lineItem.files = copiedFiles.map((file) => file.key)

  const withFiles = updateFiles({ quote: updatedQuote, files: copiedFiles })

  return calculate ? calculateQuote({ quote: withFiles, options }) : withFiles
}
